import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";
import Swiper, { Pagination, Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
// import './flex-font-layout_2.0.1';

pageTop('#toTop', false);

const mySwiper = new Swiper('.swiper', {
  modules: [ Pagination, EffectFade ],
  modules: [ Pagination, Autoplay, EffectFade ],
  autoplay: {
    delay: 3000,
  },
  speed: 3000,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  loop: true,
  pagination: {
    el: '.swiper-pagination'
  },

});

const workSwiper = new Swiper('.p-works__swiper', {
  modules: [ Pagination, Autoplay, Navigation ],
  centeredSlides: true,
  spaceBetween: 50,
  autoplay: {
    delay: 3000,
  },
  speed: 700,
  loop: true,
  pagination: {
    el: '.swiper-pagination'
  },
  navigation: false,
  slidesPerView: 2.0,
  breakpoints: {
    768: {
      slidesPerView: 1.8,
      spaceBetween: 150,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    }
  }

});

$(function() {

  $('#serviceBtn').on('click', function(e) {
    if($(e.target).hasClass('p-header__navi__link--active')) {
      $(e.target).removeClass('p-header__navi__link--active');
      $('html,body').css({overflow: 'visible'});
    } else {
      $(e.target).addClass('p-header__navi__link--active');
      $('html,body').css({overflow: 'hidden'});
    }
    $('#modal-service').toggle();
    return false;
  });

  $('#searchBtn').on('click', function(e) {
    var clientRect = e.target.getBoundingClientRect();
    var $topPos = 80 - clientRect.top;
    console.log(clientRect.top);
    $('#searchBox').css({top: `${$topPos}px`}).toggle();

    return false;
  });

  $('#burgerBtn').on('click', function(e) {
    if($('#burgerBtn').hasClass('c-burger--active')) {
      $('#burgerBtn').removeClass('c-burger--active');
      $('#spNavi').hide();
    } else {
      $('#burgerBtn').addClass('c-burger--active');
      $('#spNavi').show();
    }

    return false;
  });

  $('.mw_wp_form form').addClass('h-adr');
  new YubinBango.MicroformatDom();


});
